import { useState, useCallback } from "react";

// Simple toast hook to avoid import errors
// In a real app, this would be connected to a Provider or a library like react-hot-toast
export const useToast = () => {
  const toast = useCallback(({ title, description, variant }) => {
    console.log(`[Toast] ${variant || "info"}: ${title} - ${description}`);
    // You could replace this with a real toast implementation
  }, []);

  return { toast };
};
